import PanelHeader from './panel-header';

export default PanelHeader;